import { useTranslate } from "@similarweb/i18n-provider";
import { Button, EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { ConversionRateEmptyStateType } from "app/pages/website-analysis/TrafficAndEngagement/conversionRateEmptyStateUtils";
import { navigateToSupportedCountry } from "app/pages/website-analysis/TrafficAndEngagement/conversionRateEmptyStateUtils";

import { CONVERSION_RATE_TRANSLATION_KEYS } from "app/pages/website-analysis/TrafficAndEngagement/Components/single/ConversionRate/const";

interface IConversionRateChartEmptyStateProps {
    emptyStateType: ConversionRateEmptyStateType | null;
}

const AnalyzeWorldwideCta = () => {
    const { translate } = useTranslate();

    return (
        <Button
            onClick={navigateToSupportedCountry}
            type="outlined"
            data-automation="conversion-rate-chart-empty-state-worldwide-cta"
        >
            {translate(CONVERSION_RATE_TRANSLATION_KEYS.emptyCountryNotSupportedCta)}
        </Button>
    );
};

export const ConversionRateChartEmptyState = ({ emptyStateType }: IConversionRateChartEmptyStateProps) => {
    const { translate } = useTranslate();

    const isCountryNotSupported = emptyStateType === "CountryNotSupported";

    return (
        <Flex
            justifyContent="center"
            alignItems="center"
            flex="1"
            padding="40px 24px"
            data-automation="conversion-rate-chart-empty-state"
        >
            <EmptyState
                title={translate(
                    isCountryNotSupported
                        ? CONVERSION_RATE_TRANSLATION_KEYS.emptyCountryNotSupportedTitle
                        : CONVERSION_RATE_TRANSLATION_KEYS.emptyNoDataTitle,
                )}
                subtitle={translate(
                    isCountryNotSupported
                        ? CONVERSION_RATE_TRANSLATION_KEYS.emptyCountryNotSupportedSubtitle
                        : CONVERSION_RATE_TRANSLATION_KEYS.emptyNoDataSubtitle,
                )}
                CtaButtons={isCountryNotSupported ? AnalyzeWorldwideCta : undefined}
            />
        </Flex>
    );
};
